import * as api from '../../services/refundVerify'

export const FETCH_REFUNDVERIFYS= 'FETCH_REFUNDVERIFYS';



export const fetchRefundverifys = (params, pagination, sort, extra) => {

    return {
        type: FETCH_REFUNDVERIFYS,
        payload: {
            promise: api.findRefundverifys(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/refundVerify.js